export function getError(error: unknown): Error;
export function getError(origin: string, error?: unknown): Error;
export function getError(originOrError: string | unknown, errorInput?: unknown): Error;
export function getError(originOrError: string | unknown, errorInput?: unknown): Error {
  const origin = typeof originOrError === 'string' ? originOrError : undefined;
  const unknownError = origin ? errorInput : originOrError;
  const error = unknownError instanceof Error ? unknownError : Error(parseMessage(unknownError));
  return origin ? Error(origin, { cause: error }) : error;
}

const parseMessage = (error: unknown): string =>
  error === undefined
    ? 'undefined'
    : error === null
      ? 'null'
      : error === ''
        ? 'empty-string'
        : hasMessage(error)
          ? error.message
          : JSON.stringify(error);

const hasMessage = (error: unknown): error is { message: string } => !!(error as Error)?.message;
